module.exports = __webpack_public_path__ + "static/media/hall-paloalto623.f5f403b5.png";